// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AdditionalServices_KvResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /so/additional_services/kv
 *
 * Key-value list of additional services for dropdown selects.
 * Wire shape: `dados: AdditionalServices_KvRow[]` — emitted directly as `dados`.
 */
import type { AdditionalServices_KvRow } from './AdditionalServices_KvRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type AdditionalServices_KvResponseDados = AdditionalServices_KvRow[];

export type AdditionalServices_KvResponse = ApiResponse<AdditionalServices_KvResponseDados>;

registerResponseContract('AdditionalServices_KvResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      value: { type: 'number',  required: true },
      label: { type: 'string',  required: true },
    },
  },
})
